import { Client } from '@microsoft/microsoft-graph-client';

// Create Graph client with access token
const getGraphClient = (accessToken) => {
  return Client.init({
    authProvider: (done) => {
      done(null, accessToken);
    }
  });
};

// Get calendar events from Microsoft Graph
export const getCalendarEvents = async (accessToken, startDateTime, endDateTime) => {
  try {
    const graphClient = getGraphClient(accessToken);
    
    const events = await graphClient
      .api('/me/calendar/events')
      .select('id,subject,start,end,organizer,onlineMeeting,isOrganizer,attendees,webLink')
      .filter(`start/dateTime ge '${startDateTime}' and end/dateTime le '${endDateTime}'`)
      .orderby('start/dateTime')
      .get();

    return events.value || [];
  } catch (error) {
    console.error('Error fetching calendar events:', error);
    throw error;
  }
};

// Get user photo from Microsoft Graph
export const getUserPhoto = async (accessToken, userEmail) => {
  try {
    const graphClient = getGraphClient(accessToken);
    
    // Try to get photo by user email
    const photoResponse = await graphClient
      .api(`/users/${userEmail}/photo/$value`)
      .get();

    // Convert blob to data URL
    const blob = new Blob([photoResponse], { type: 'image/jpeg' });
    return URL.createObjectURL(blob);
  } catch (error) {
    // Photo not available or user not found
    console.warn(`Photo not available for user ${userEmail}:`, error);
    return null;
  }
};

// Check if organizer has joined the meeting (simplified version)
export const getOrganizerJoinStatus = async (event, currentUserEmail, accessToken) => {
  try {
    // For now, we'll use a simplified approach
    // In a real implementation, you might check meeting participants or attendance reports
    
    // If the meeting has an online meeting URL and is currently in progress, 
    // we can assume some basic logic
    const now = new Date();
    const startTime = new Date(event.start.dateTime);
    const endTime = new Date(event.end.dateTime);
    
    // If meeting is in progress and has online meeting info, assume organizer might have joined
    if (now >= startTime && now < endTime && event.onlineMeeting) {
      // This is a simplified assumption - in reality you'd need to check actual attendance
      return Math.random() > 0.5; // Random for demo purposes
    }
    
    return false;
  } catch (error) {
    console.warn('Error checking organizer join status:', error);
    return false;
  }
};

// Get meeting participants (if available)
export const getMeetingParticipants = async (accessToken, meetingId) => {
  try {
    const graphClient = getGraphClient(accessToken);
    
    // This would require additional permissions and might not be available for all meetings
    const participants = await graphClient
      .api(`/me/calendar/events/${meetingId}/attendees`)
      .get();

    return participants.value || [];
  } catch (error) {
    console.warn('Error fetching meeting participants:', error);
    return [];
  }
};